import { DataBean } from "../DataBean";

export class AddCrossRef extends DataBean {


    public async getProductCrossReferenceCatalog(idProduct: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductCrossReferenceCatalog_Number", [idProduct]);
    }
    public async deleteProductCrossReference(idProductCrossReference: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteProductCrossReference_Number", [idProductCrossReference]);
    }
    public async addCrossReferenceToProduct(idProduct: any, idProductParent: any, name: any, description: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.inventory.ProductCrossReference_addCrossReferenceToProduct_Number_Number_String_String", [idProduct, idProductParent, name, description]);
    }

}